exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-users-page--embedded[data-v-4fec3d2e],.settings-users-page[data-v-4fec3d2e]{padding:0}.settings-users-page__heading[data-v-4fec3d2e]{margin-bottom:10px;font-size:16px;font-weight:600;color:#303133}.settings-users-page__toolbar[data-v-4fec3d2e]{margin-bottom:10px;display:flex;align-items:center;gap:8px}.settings-users-page__card[data-v-4fec3d2e]{border:0}.settings-users-page__role-select[data-v-4fec3d2e]{width:100%;margin-top:16px}.settings-users-page__field-tip[data-v-4fec3d2e]{font-size:12px;color:#909399;margin-top:4px}.settings-users-page__readonly-text[data-v-4fec3d2e]{color:#606266}.settings-users-page__danger[data-v-4fec3d2e]{color:#f56c6c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fec3d2e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/SettingsUsers.vue
// module id = tIdo
// module chunks = 0